(() => {
function $c2848ebcf924d7cd$var$loadReachWrapperScript(url) {
    return new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = url;
        script.onload = ()=>resolve();
        script.setAttribute("id", "reach-init-script");
        script.onerror = (error)=>reject(error);
        document.body.appendChild(script);
    });
}
let $c2848ebcf924d7cd$var$scriptLoaded = false;
// Then load external script
// loadReachWrapperScript("http://localhost:1234/widget.js?95806261")
$c2848ebcf924d7cd$var$loadReachWrapperScript("https://store.loyative.com/widget.js?95806261").then(()=>{
    $c2848ebcf924d7cd$var$scriptLoaded = true;
    $c2848ebcf924d7cd$var$pendingXReachStoreCalls.forEach(({ args: args, resolve: resolve, reject: reject }, index)=>{
        try {
            const result = window.xReachStore?.(...args);
            const id = $c2848ebcf924d7cd$var$extractIdFromParams(...args);
            $c2848ebcf924d7cd$var$injectReachToolsPanelContainer(id);
            window.xReachCategories?.(`id=reach--categories`);
            window.xReachMiniCart?.(`id=reach--mini-cart`);
            resolve(result);
        } catch (error) {
            reject(error);
        }
    });
// Continue with code that depends on the loaded script
}).catch((error)=>{
    console.error("Failed to load script:", error);
});
// Create a queue to store calls before the script is loaded
const $c2848ebcf924d7cd$var$pendingXReachStoreCalls = [];
let $c2848ebcf924d7cd$var$originalXProductBrowser = null;
window.xReachStore = (...args)=>{
    return new Promise((resolve, reject)=>{
        $c2848ebcf924d7cd$var$pendingXReachStoreCalls.push({
            args: args,
            resolve: resolve,
            reject: reject
        });
    });
};
function $c2848ebcf924d7cd$var$injectReachToolsPanelContainer(id) {
    const reachToolsPanelDiv = document.createElement("div");
    reachToolsPanelDiv.setAttribute("id", "reach--tools-panel");
    reachToolsPanelDiv.style.visibility = "hidden";
    reachToolsPanelDiv.style.display = "flex";
    reachToolsPanelDiv.style.justifyContent = "space-between";
    reachToolsPanelDiv.style.alignItems = "flex-start";
    reachToolsPanelDiv.style.width = "100%";
    reachToolsPanelDiv.style.marginBottom = "0.5em";
    reachToolsPanelDiv.style.gap = "24px";
    reachToolsPanelDiv.classList.add("reach--tools-panel");
    const categoriesDiv = document.createElement("div");
    categoriesDiv.setAttribute("id", "reach--categories");
    categoriesDiv.style.flexGrow = "1";
    const reachMiniCartDiv = document.createElement("div");
    reachMiniCartDiv.setAttribute("id", "reach--mini-cart");
    reachToolsPanelDiv.appendChild(categoriesDiv);
    reachToolsPanelDiv.appendChild(reachMiniCartDiv);
    document.querySelector(`#${id}`)?.prepend(reachToolsPanelDiv);
}
function $c2848ebcf924d7cd$var$extractIdFromParams(...args) {
    const id = args.map((arg)=>{
        if (typeof arg !== "string") return undefined;
        const possiblyId = arg.split("id=")[1].split("&")[0];
        return possiblyId;
    }).filter((x)=>x != null)[0];
    return id;
}

})();
//# sourceMappingURL=index.js.map
